import React from "react";
import {Icon} from "gd-react";
import './RadioWithImage.scss'

class RadioWithImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: props.value
        };
    }

    handleChange = (value) => {
        this.setState({selected: value});
        if (this.props.onChange) this.props.onChange(value);
    };

    renderOption = (option) => {
        return (
            <label
                key={option.value}
                className={`radio-option ${this.state.selected === option.value ? "selected" : ""}`}
            >
                <input
                    type="radio"
                    name={this.props.name}
                    value={option.value}
                    checked={this.state.selected === option.value}
                    onChange={() => this.handleChange(option.value)}
                />

                <div className={'toggle'}>
                    <div className={'dot'}/>
                </div>

                {option.image && (
                    <div className={'label-image'} style={{backgroundImage: `url("${option.image}")`}}/>
                )}

                {option.icons && option.icons.length && (
                    <div className={'row radio-icon-row'}>
                        {option.icons.map((icon, index) => (
                            <Icon icon={icon.icon} size={'25'} color={icon.color} className="radio-icon"/>))}
                    </div>
                )}

                <span className={'radio-label'}>{option.label}</span>
                {option.description && <p className={'radio-description'}>{option.description}</p>}
            </label>
        );
    };

    render() {
        const {options = [], columns = 2} = this.props;

        return <div className={'radio-with-image-wrapper'}>
            <p className={'main-label'}>{this.props.label}</p>
            <div className={`radio-with-image columns-${columns}`}>
                {options.map(this.renderOption)}
            </div>
        </div>;
    }
}

export default RadioWithImage;
